import { Toaster } from '@estac1/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@estac1/ui/fonts.css';
import './styles.css';
import { initErrorReporting } from './lib/error-reporting.js';
import { queryClient } from './lib/query-client.js';
import { buildRouter } from './router.js';

initErrorReporting();

const router = buildRouter(queryClient);

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster />
    </QueryClientProvider>
  </StrictMode>,
);
